import { type FormFieldNestedListOptions, type FormFieldNestedListValues, IkeFieldType } from '@ikegps/core-api';
import { FormModelField, type FormModelFieldState, FormModelMutatorField } from '../form.field';
import { FormModelFieldNestedListBuilder } from './form.nested.list.builder';

export interface CollectionModelFieldNestedListSelection {
	title: string;
	value: string;
	code?: string;
	color?: string;
}

export interface FormModelFieldNestedListState extends FormModelFieldState {
	options: FormFieldNestedListOptions;
}

export class FormModelMutatorNestedList extends FormModelMutatorField<FormModelFieldNestedList> {
	init(options: FormFieldNestedListOptions) {
		if (options == null) {
			return;
		}

		this.state.setFieldValue(this.field.fieldId, {
			...this.field.stateValue,
			options: JSON.parse(JSON.stringify(options)),
		});
	}

	get builder(): FormModelFieldNestedListBuilder {
		const stateValue = this.field.stateValue;

		if (stateValue != null && stateValue.options != null) {
			return new FormModelFieldNestedListBuilder(JSON.parse(JSON.stringify(stateValue.options)));
		}

		return new FormModelFieldNestedListBuilder();
	}

	clear() {
		this.init({ title: '', values: [] });
	}
}

export class FormModelFieldNestedList extends FormModelField<FormModelFieldNestedListState> {
	static isNestedList(field: FormModelField): field is FormModelFieldNestedList {
		return field.type === IkeFieldType.NESTED_LIST;
	}

	private _NLMutator?: FormModelMutatorNestedList;
	override get Mutator(): FormModelMutatorNestedList {
		const mut = new FormModelMutatorNestedList(this);
		if (this._NLMutator == null) {
			this._NLMutator = mut;
		}
		return this._NLMutator;
	}

	get options(): FormFieldNestedListOptions {
		return this.stateValue.options || { title: '', values: [] };
	}

	findOptions(selections: string[]): FormFieldNestedListValues[] {
		return FormModelFieldNestedList.findNestedListSelections(this.options, selections);
	}

	static findNestedListSelections(
		options: FormFieldNestedListOptions,
		selections: string[]
	): FormFieldNestedListValues[] {
		if (!Array.isArray(selections) || selections.length === 0 || selections[0] == null) {
			return [];
		}

		const searchItem = String(selections[0]);
		if (options == null) {
			return [];
		}

		const option = options.values.find(({ value }) => String(value) === searchItem);
		if (option == null) {
			return [];
		}

		const values: FormFieldNestedListValues[] = [option];

		if (option.options == null) {
			return values;
		}

		const nextOption = this.findNestedListSelections(option.options, selections.slice(1));
		if (nextOption.length === 0) {
			return [];
		}

		return values.concat(nextOption);
	}

	getField() {
		return this;
	}
}
